import type { Vec2 } from "./types";

export class Camera {
  x = 0;
  y = 0;
  zoom = 1;

  viewportW = 0;
  viewportH = 0;

  setViewport(w: number, h: number): void {
    this.viewportW = w;
    this.viewportH = h;
  }

  /** Smoothly trail the target with a small lead in the heading direction. */
  follow(target: Vec2, heading: number, dt: number): void {
    const lead = 70;
    const tx = target.x + Math.cos(heading) * lead;
    const ty = target.y + Math.sin(heading) * lead;
    const k = 1 - Math.exp(-dt * 6);
    this.x += (tx - this.x) * k;
    this.y += (ty - this.y) * k;
  }

  /** World → screen pixel coords. */
  worldToScreen(wx: number, wy: number): Vec2 {
    return {
      x: (wx - this.x) * this.zoom + this.viewportW / 2,
      y: (wy - this.y) * this.zoom + this.viewportH / 2,
    };
  }

  /** Screen pixel coords → world coords. */
  screenToWorld(sx: number, sy: number): Vec2 {
    return {
      x: (sx - this.viewportW / 2) / this.zoom + this.x,
      y: (sy - this.viewportH / 2) / this.zoom + this.y,
    };
  }
}
